import React, { type ComponentPropsWithoutRef } from 'react';

const ConditionalProfileCard = importCond<
	typeof import('./index.tsx'),
	typeof import('./async-old.tsx')
>('empanada_profilecard_sync_trigger_import_final', './index.tsx', './async-old.tsx');

// inline this into usages when cleaning up empanada_profilecard_sync_trigger_import_final
export default function ProfileCard(
	props: ComponentPropsWithoutRef<typeof ConditionalProfileCard>,
) {
	return <ConditionalProfileCard {...props} />;
}
